export default defineNuxtPlugin(() => {
  const customScripts = document.querySelectorAll(
    'script[type="text/delayed-javascript"]',
  )
  customScripts.forEach((script) => {
    eval(script.innerHTML)
  })
})
